'use client'

import type { TaskFlowPhase, TaskFlowRequest } from '@/lib/task-flow/taskFlowStore'

export default function GenericTaskFlow({
  request,
  phase,
}: {
  request: TaskFlowRequest
  phase: TaskFlowPhase
}) {
  return (
    <div className="h-full w-full overflow-hidden rounded-none border border-cyan-400/10 bg-[#030712] text-cyan-50 md:rounded-[32px]">
      <div className="border-b border-cyan-400/10 px-6 py-5">
        <div className="text-[11px] uppercase tracking-[0.28em] text-cyan-300/60">
          Task Flow
        </div>
        <div className="mt-2 text-2xl font-semibold">{request.title}</div>
        {request.subtitle ? (
          <div className="mt-2 text-sm text-cyan-100/60">{request.subtitle}</div>
        ) : null}
      </div>

      <div className="p-6">
        <div className="rounded-3xl border border-cyan-400/10 bg-cyan-400/[0.04] p-5">
          <div className="text-sm text-cyan-100/70">
            Task type: <strong>{request.taskType}</strong>
          </div>
          <div className="mt-2 text-sm text-cyan-100/70">
            Phase: <strong>{phase}</strong>
          </div>
        </div>
      </div>
    </div>
  )
}